import React from 'react'
import { Subscribe } from 'unstated'
import CourseStore from '../../../Store/CourseStore'
import { stripHtmlTags } from '../../../../../Helpers/Misc'
import {
  Accordion,
  AccordionItem,
  AccordionItemBody,
  AccordionItemTitle,
} from 'react-accessible-accordion'
import 'react-accessible-accordion/dist/minimal-example.css'

const HtmlToReactParser = require('html-to-react').Parser

const About = () => (
  <Subscribe to={[CourseStore]}>
    {({ state }) => (
      <div className='about'>
        <Accordion accordion={false}>
          <AccordionItem expanded={true}>
            <AccordionItemTitle hideBodyClassName={'closed'}>
              <h1>Course Objectives</h1>
              <p>{stripHtmlTags(state.objectives)}</p>
            </AccordionItemTitle>
            <AccordionItemBody>
              {new HtmlToReactParser().parse(state.objectives)}
            </AccordionItemBody>
          </AccordionItem>
          <AccordionItem expanded={true}>
            <AccordionItemTitle hideBodyClassName={'closed'}>
              <h1>Prerequisites</h1>
              <p>{stripHtmlTags(state.preRequisites)}</p>
            </AccordionItemTitle>
            <AccordionItemBody>
              {new HtmlToReactParser().parse(state.preRequisites)}
            </AccordionItemBody>
          </AccordionItem>
        </Accordion>
        <p>{}</p>
      </div>
    )}
  </Subscribe>
)

export default About
